import { render, staticRenderFns } from "./ViSchoolList.vue?vue&type=template&id=553abf29&scoped=true"
import script from "./ViSchoolList.vue?vue&type=script&lang=js"
export * from "./ViSchoolList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553abf29",
  null
  
)

export default component.exports